import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import {PluginObject} from "vue";
import {GoogleMapsApiKey} from "@/modules/constants";

/**
 * This is a DRY way to init the vue2-google-maps component. It async loads the google maps script(s) so that the map component
 * gets initialized and available for use. Used in SioReg and Areadefinition components. Important to use the same libraries
 * spec in both components, otherwise error would occur when user first opened page with SioReg component and then went to
 * Areadefinition page, because it would then be flagged as loaded and ready, but missing a library.
 */
export const initVueGoogleMaps = () => {
    Vue.use(VueGoogleMaps as PluginObject<any>, {
        load: {
            key: GoogleMapsApiKey,
            libraries: "places,geometry",
            loading: "async"
        }
    });
};
